import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'
import { toggleKambiVisibility } from '@core/Areas/KambiClient/helpers'
import { setNewKambiSportsOfferingIntegrationSetting } from '@core/Areas/Settings/Store'
import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'

// TEMP ONLY: remove when shipping to wider PROD audience
export const KambiSportsOfferingIntegrationOverrideSetting: React.FC = () => {
  const dispatch = useDispatch()
  const isEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  return (
    <SettingItemWithCheckbox
      isEnabled={isEnabled}
      label='Enable new sports offering'
      description='Temporarily switch between old and new sport offerings.'
      onToggle={() => {
        dispatch(setNewKambiSportsOfferingIntegrationSetting(!isEnabled))
        // fix for bug where kambi client shows when toggling sport setting
        dispatch(setKambiClientVisibility(false))
        toggleKambiVisibility(false)
      }}
    />
  )
}
